import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Button from '@material-ui/core/Button'

const StoryTwoLearnMoreBtn = ({ btnClassName, url, text }) => (
  <Link to={url}>
    <Button
      size="medium"
      variant="raised"
      color="primary"
      classes={{ root: btnClassName }}
    >
      {text}
    </Button>
  </Link>
)

StoryTwoLearnMoreBtn.propTypes = {
  btnClassName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
}

export default StoryTwoLearnMoreBtn



// WEBPACK FOOTER //
// ./src/components/Storiespage/StoryTwoLearnMoreBtn.js